/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UnregisterAdvertiserRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {UnregisterAdvertiserResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const unregisterAdvertiser = (request:UnregisterAdvertiserRequest, options?: CashRequestOptions) => post<UnregisterAdvertiserRequest, UnregisterAdvertiserResponse>("/2.0/cash/unregister-advertiser", request, {...options, rejectOnError: true })